<ng-container [ngSwitch]="type">
  <button
    *ngSwitchCase="buttonTypesEnum.Stroked"
    mat-stroked-button
    [color]="color"
    [disabled]="disabled || isRequestMade"
    [ngClass]="class || ''"
    [type]="buttonBehaviourType || 'button'"
    (click)="onButtonClick()"

    class="btn"
  >
    <ng-container *ngTemplateOutlet="buttonContentTemplate"></ng-container>
  </button>

  <button
    *ngSwitchCase="buttonTypesEnum.Flat"
    mat-flat-button
    [color]="color"
    [disabled]="disabled || isRequestMade"
    [ngClass]="class || ''"
    [type]="buttonBehaviourType || 'button'"
    (click)="onButtonClick()"

    class="btn"
  >
    <ng-container *ngTemplateOutlet="buttonContentTemplate"></ng-container>
  </button>

	<button
		*ngSwitchCase="buttonTypesEnum.Raised"
		mat-raised-button
		[color]="color"
		[disabled]="disabled || isRequestMade"
		[ngClass]="class || ''"
		[type]="buttonBehaviourType || 'button'"
		(click)="onButtonClick()"
		class="btn"
	>
		<ng-container *ngTemplateOutlet="buttonContentTemplate"></ng-container>
	</button>

  <button
    *ngSwitchCase="buttonTypesEnum.Basic"
    mat-button
    [color]="color"
    [disabled]="disabled || isRequestMade"
    [ngClass]="class || ''"
    [type]="buttonBehaviourType || 'button'"
    (click)="onButtonClick()"

    class="btn"
  >
    <ng-container *ngTemplateOutlet="buttonContentTemplate"></ng-container>
  </button>
</ng-container>

<ng-template #buttonContentTemplate>
  <ng-container *ngIf="!isRequestMade; else preloader">
    {{ content }}
  </ng-container>

  <ng-template #preloader>
    <div class="preloader-secondary">
      <app-preloader [secondaryColor]="true"></app-preloader>
    </div>
  </ng-template>
</ng-template>
